import { Component, EventEmitter, Output } from '@angular/core';
import { AsyncPipe, CommonModule, NgIf } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { LinkIssueService } from '../../services/link-issue.service';
import Swal from 'sweetalert2';
import { showErrorSwal } from '@asamco/utils';

@Component({
  selector: 'appshell-admin-link-overview-link-issue-modal',
  standalone: true,
  imports: [CommonModule, NgIf, AsyncPipe],
  templateUrl: './admin-link-overview-link-issue-modal.component.html',
  styleUrl: './admin-link-overview-link-issue-modal.component.scss',
})
export class AdminLinkOverviewLinkIssueModalComponent {
  public title: string = "Link issue report"
  public visibleSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)


  @Output() issueFixed: EventEmitter<void> = new EventEmitter<void>(); // <-- New
  public issues: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([])

  constructor(private linkIssueService: LinkIssueService) { }

  ngOnInit(): void {

  }

  close() {
    this.visibleSubject.next(false)
  }

  open(issues: any[]) {
    this.issues.next(issues);
    this.visibleSubject.next(true);
  }

  fixIssue(issue: any) {
    this.linkIssueService.FixLinkIssue(issue).subscribe(
      (result: any) => {
        Swal.fire({
          title: 'Action executed',
          text: result,
          icon: 'success',
        }).then(() => {
          this.close(); // Close modal after user sees the alert
          this.issueFixed.emit(); // <-- Notify parent
        });
      },
      error => {
        showErrorSwal(error);
      },
      () => {
        // 'onCompleted' callback. Can be used for logging or cleanup
      }
    );
  }
}
